<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>

<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5 login-bg"></b-col>

      <!-- Reset Password-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-text class="mb-2">
            <img class="full-width" height="auto" src="~@/assets/images/logo/logo.svg" alt="logo">
          </b-card-text>

          <!-- form -->
          <validation-observer ref="loginValidation">
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent
            >
              <!-- email -->
              <b-form-group
                label="Email"
                label-for="login-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required" cy="forgot-email"
                >
                  <b-form-input
                    id="login-email"
                    v-model="email"
                    :state="errors.length > 0 ? false:null"
                    name="login-email"
                    placeholder="email"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                @click="validationForm"
              >
                Request Reset Code
              </b-button>

              <b-button
                variant="outline-primary"
                block
                @click="goToResetPassword()"
              >
                Already have a code?
              </b-button>

              <b-button
                variant="outline-primary"
                block
                :to="{name: 'login'}"
              >
                Back
              </b-button>
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { required } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import VisitorUsersService from '@/services/OffsiteUsersService';

export default {
  components: {},
  mixins: [togglePasswordVisibility],
  data() {
    return {
      password: '',
      email: '',
      sideImg: require('@/assets/images/pages/login-v2.svg'),
      bgImage: require('@/assets/images/pages/login-bg.jpg'),
      required,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    validationForm() {
      this.$refs.loginValidation.validate().then(success => {
        if (success) {
          this.resetPassword();
        }
      })
    },
    resetPassword() {
      VisitorUsersService.requestPasswordReset(this.email).then(() => {
        this.$toast.success('Password Reset Request Successful. You will receive an email shortly'
          + 'with a code to enter here', {
          toastClassName: ['toast-std', 'success-toast'],
          timeout: 10000,
        });

        this.goToResetPassword();
      }).catch(() => {
        this.$toast.error('Something went wrong, please check your details and try again', {
          toastClassName: ['toast-std', 'warning-toast'], timeout: 5000,
        });
      })
    },
    goToResetPassword() { // only navigate if form is valid, since email is required
      this.$refs.loginValidation.validate().then(success => {
        if (success) {
          this.$router.push({ name: 'reset-password', params: { email: this.email } });
        }
      });
    },
  },
}
</script>
